import styled from "styled-components";

export const ThinProgressBarBox = styled.div`
      @keyframes loadingAnimation {
        0% {
          left: -100%;
        }
        100% {
          left: 100%;
        }
      }
      
      width: 100%;
      height: 40%;

      background-image: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 20%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0.8) 80%,
      rgba(255, 255, 255, 0) 100%);
      
      position: absolute;
      animation: loadingAnimation 0.8s linear infinite;
      border-radius: 50px;
`;


